import StripePaymentBlock from './StripePaymentBlock'

export default StripePaymentBlock
